import { Icon } from '@mui/material';
import cx from 'classnames';
import React from 'react';

function MaterialIcon({ icon, size, style, className, color, ...other }: any) {
  const defaultStyle = {
    fontSize: size,
  };

  if (color) {
    // @ts-expect-error TS(2339): Property 'color' does not exist on type '{ fontSiz... Remove this comment to see the full error message
    defaultStyle.color = color;
  }

  return (
    <Icon
      className={cx('material-icons', { [className]: !!className })}
      style={{ ...defaultStyle, ...style }}
      {...other}
    >
      {icon}
    </Icon>
  );
}

export default MaterialIcon;
